
document.addEventListener("DOMContentLoaded", function() {
  // Initialize Swipers
  var thumbSwiper = new Swiper(".custom-featured-product .thumbSwiper", {
    spaceBetween: 30,
    slidesPerView: 4,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom-featured-product .thumbSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      1025: { direction: "horizontal" },
      481: { direction: "horizontal", spaceBetween: 20, },
      0: { slidesPerView: 4, spaceBetween: 12 }
    }
  });

  var featuredSwiper = new Swiper(".custom-featured-product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
      autoHeight: true, // 👈 key line

    navigation: {
      nextEl: ".custom-featured-product .featuredSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });  })




  $(document).on('click', '.custom-featured-product .featured-product .product__info-container .custom_quantity_wrapper .custom_quantity button.qty_btn ', function(){

    $('.qty_btn').removeClass('active');
    $(this).addClass('active');
    var qunatity = $(this).attr('data_index');
    $('.product-form__input .quantity__input').val(qunatity);
})



// Custom Product Page Slider
document.addEventListener("DOMContentLoaded", function() {
  // Initialize Swipers
  var thumbSwiper = new Swiper(".custom_pdp .thumbSwiper", {
    spaceBetween: 30,
    slidesPerView: 4,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom_pdp .thumbSwiper .swiper-button-next",
      prevEl: ".custom_pdp .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      1025: { direction: "horizontal" },
      481: { direction: "horizontal", spaceBetween: 20, },
      0: { slidesPerView: 4, spaceBetween: 12 }
    }
  });

  var featuredSwiper = new Swiper(".custom_pdp .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
      autoHeight: true, // 👈 key line

    navigation: {
      nextEl: ".custom_pdp .featuredSwiper .swiper-button-next",
      prevEl: ".custom_pdp .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  }); 




$(window).on("scroll", function () {
  if ($(this).scrollTop() > 5) {
    $(".custom_pdp header").addClass("bg-white");
  } else {
    $(".custom_pdp header").removeClass("bg-white");
  }
});


 })
